module.exports = __webpack_public_path__ + "img/athena_carousel_10.3908c9e2.jpg";